import { render, staticRenderFns } from "./BeneficiarieUpdateRequests.vue?vue&type=template&id=2f5c9867&scoped=true&"
import script from "./BeneficiarieUpdateRequests.vue?vue&type=script&lang=js&"
export * from "./BeneficiarieUpdateRequests.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiarieUpdateRequests.vue?vue&type=style&index=0&id=2f5c9867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c9867",
  null
  
)

export default component.exports